/* eslint-disable array-callback-return */
/* eslint-disable arrow-parens */
// import * as utils from '@/utils/utils';

import services from '../services/account.js'
import { message } from 'antd'

const {
  getUserInfo,
  getApprovalProgress,
  login,
  logout,
  sendEmailVerification,
  checkEmail,
  sendPhoneVerification,
  emailRegister,
  emailReset,
  phoneRegister,
  phoneReset,
  registerInfoReport,
  getArrearsNotice,
  getPaymentnotice,
  getChangeCertnotice,
} = services

const namespace = 'account'

export default {
  namespace,
  state: {
    isLogin: false,
    userInfo: {
      code: '',
      enterpriseName: '',
      enterpriseAddress: '',
      legalPerson: '',
      legalPersonPosition: '',
      enterprisePrincipal: '',
      enterprisePrincipalPosition: '',
      enterpriseType: null,
      enterpriseTypeName: '',
      enterpriseWeb: '',
      establishedTime: '',
      contactName: '',
      contactPhone: '',
      contactPosition: '',
      enterpriseFax: '',
      contactQq: '',
      contactLandline: '',
      contactDepartment: '',
      applicationTime: '',
      registrationTime: '',
      renewalTime: '',
      associationName: '',
      memberTypeName: '',
      businessScope: null,
      enterpriseProvinceId: null,
      enterpriseCityId: null,
      enterpriseAreaId: null,
      generalList: [],
      generalValueList: [],
      majorList: [],
      majorValueList: [],
      qualificationFileList: [],
      companyFileList: [],
      memberQualityFileVO: {
        generalMemberQualityFileListVOS: [],
        majorMemberQualityFileListVOS: [],
      },
    },
    approvalProgress: [
      {
        title: '11', //
        description: null, // 描述信息
        status: 'finish', // 状态 finish:节点完成 process:当前进行中 wait:未进行 error:出错
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'process', // 状态
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'wait ', // 状态
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'error', // 状态
      },
    ],
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *changeState({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 获取用户信息
    *getUserInfo({ payload, callback }, { call, put }) {
      const res = yield call(getUserInfo, { ...payload })
      let generalValueList = []
      let majorValueList = []
      if (res.data.generalList) {
        res.data.generalList.map((item) => {
          generalValueList.push(item.code)
        })
      }
      if (res.data.majorList) {
        res.data.majorList.map((item) => {
          majorValueList.push(item.code)
        })
      }
      yield put({
        type: 'updateState',
        payload: {
          userInfo: {
            ...res.data,
            generalValueList: generalValueList,
            majorValueList: majorValueList,
          },
        },
      })
      if (res.success && callback) {
        callback(res.data)
      }
      // if (res.data.type === -1) {
      //   window.location.href = '/#/account/regInformation'
      // }
    },

    // 获取用户的审批进度
    *getApprovalProgress({ payload, callback }, { call, put }) {
      const res = yield call(getApprovalProgress, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            approvalProgress: res.data,
          },
        })
      } else {
        message.error(res.globalError)
      }
    },

    // 登录
    *login({ payload, callback }, { call }) {
      const res = yield call(login, { ...payload })
      if (res.success) {
        message.success('登录成功')
        window.location.href = '/#/manage/message'
        // if (res.data.type === -1) {
        //   window.location.href = '/#/account/regInformation'
        // } else {
        //   window.location.href = '/#/manage/member'
        // }
      } else {
        message.error(res.globalError)
      }
    },

    // 退出登录
    *logout({ payload, callback }, { call }) {
      const res = yield call(logout)
      if (res.success) {
        message.success('退出登录')
        window.location.href = '/'
      } else {
        message.error(res.globalError)
      }
    },

    // 邮箱发送验证码 发送类型 0 注册 1 重置
    *sendEmailVerification({ payload, callback }, { call }) {
      const res = yield call(sendEmailVerification, { ...payload })
      if (res.success) {
        message.success('获取成功')
      } else {
        message.error(res.globalError)
      }
    },

    // 邮箱验证码校验
    *checkEmail({ payload, callback }, { call }) {
      const res = yield call(checkEmail, { ...payload })
      if (res.success) {
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 手机号发送验证码 发送类型 0 注册 1 重置
    *sendPhoneVerification({ payload, callback }, { call }) {
      const res = yield call(sendPhoneVerification, { ...payload })
      if (res.success) {
        message.success('获取成功')
      } else {
        message.error(res.globalError)
      }
    },

    // 邮箱注册
    *emailRegister({ payload, callback }, { call }) {
      const res = yield call(emailRegister, { ...payload })
      if (res.success) {
        message.success('注册成功')
        window.location.href = '/#/account/login'
      } else {
        message.error(res.globalError)
      }
    },

    // 邮箱重置
    *emailReset({ payload, callback }, { call }) {
      const res = yield call(emailReset, { ...payload })
      if (res.success) {
        window.location.href = '/#/account/login'
        message.success('重置成功')
      } else {
        message.error(res.globalError)
      }
    },

    // 手机注册
    *phoneRegister({ payload, callback }, { call }) {
      const res = yield call(phoneRegister, { ...payload })
      if (res.success) {
        message.success('注册成功')
        window.location.href = '/#/account/login'
      } else {
        message.error(res.globalError)
      }
    },

    // 手机重置
    *phoneReset({ payload, callback }, { call }) {
      const res = yield call(phoneReset, { ...payload })
      if (res.success) {
        window.location.href = '/#/account/login'
        message.success('重置成功')
      } else {
        message.error(res.globalError)
      }
    },

    // 注册信息填报
    *registerInfoReport({ payload, callback }, { call }) {
      const res = yield call(registerInfoReport, { ...payload })
      if (res.success) {
        message.success('继续操作')
        window.location.href = '/#/manage/member'
      } else {
        message.error(res.globalError)
      }
    },

    // 欠费通知
    *getArrearsNotice({ payload, callback }, { call }) {
      const res = yield call(getArrearsNotice, { ...payload })
      if (res.success) {
        callback && callback(res.data)
      } else {
        message.error(res.globalError)
      }
    },

    // 缴费通知
    *getPaymentnotice({ payload, callback }, { call }) {
      const res = yield call(getPaymentnotice, { ...payload })
      if (res.success) {
        callback && callback(res.data)
      } else {
        message.error(res.globalError)
      }
    },

    // 换证通知
    *getChangeCertnotice({ payload, callback }, { call }) {
      const res = yield call(getChangeCertnotice, { ...payload })
      if (res.success) {
        callback && callback(res.data)
      } else {
        message.error(res.globalError)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
